const LIST_COMMON = "/api/commons";
const LIST_EMPLOYEE = "/api/employees";
const SHOW_EMPLOYEE = "/api/employees";
const DELETE_EMPLOYEE = "/api/employees";
const CREATE_EMPLOYEE = "/api/employees";
const UPDATE_EMPLOYEE = "/api/employees";
const GET_EMPLOYEE = "/api/employees";
const GET_INFORMATION_EMPLOYEE = "/api/employees";
const CREATE_NOTE_EMPLOYEE = "/api/employees/note";
const IMPORT_EMPLOYEE_NUMBER_OF_LEAVE = "/api/employees/imports";
const LIST_EMPLOYEE_DAYS_OFF = "/api/employees/days-off";
const UPDATE_DAYS_OFF = "/api/employees/days-off";
const LIST_CUSTOMER = "/api/customers";
const RESIGNATION = "/api/employees/resignation";
const LIST_OVERTIME_REQUEST = "/api/overtime-requests";
const SHOW_OVERTIME_REQUEST = "/api/overtime-requests";
const LIST_REMOTE_REQUEST = "/api/remote";
const SHOW_REMOTE_REQUEST = "/api/remote";
const CHART_INFORMATION = "/api/charts";
const LIST_PROJECT_CUSTOMERS = "/api/common/customers";
const FOOT_DIVISION = "/api/common/foot-division";
const GET_RESOURCE_EFFORT_STATISTICS = "/api/project-management/employees/efforts";
const GET_PROJECT_STATUS_STATISTICS = "/api/projects/project-status-statistics";
const GET_PROJECT_CHARGE_PROJECTS = "/api/project-management/overview-number-of-project";
const GET_PROJECT_IN_CHARGE_MANMONTH = "/api/project-management/overview-number-of-mm";
const GET_DATA_MM_YEAR = "/api/project-management/overview-effort";

const LIST_EMPLOYEE_TO_SELECT = "/api/common/employee-develop";
const LIST_POSITION = "/api/common/positions";

const LOGIN = "/api/login";
const REFRESH_TOKEN = "/api/refresh-token";
const ACCOUNT = "/api/account";
const CHANGE_PASSWORD = "/api/change-password";
const LIST_PROJECT = "/api/projects";
const GET_EMPLOYEE_SKILL = "/api/projects/get-employee-skill";
const GET_RESOURCE_STATISTICS = "/api/projects/resource-statistics";
const GET_RESOURCE_DIVISION_STATISTICS = "/api/projects/resource-statistics-division";
const GET_RESOURCE_SE_STATISTICS = "/api/projects/resource-statistics-se";

// Time sheet
const TIME_SHEET = "/api/timesheets";
const USER_TIME_SHEET = "/api/user/timesheets";
const USER_CHECK_IN = "/api/user/timesheets/checkin";
const USER_CHECK_OUT = "/api/user/timesheets/checkout";
const TIME_SHEET_REQUEST = "/api/timesheets/requests";
const IMPORT_TIMESHEET = "/api/timesheets/import";
const TIME_SHEET_TODAY = "/api/user/timesheets/today";
const GET_EMPLOYEE_TIMESHEET_SUMMARY = "/api/timesheets/summary";
const GET_EMPLOYEE_TIMESHEET_DETAIL = "/api/timesheets";
const GET_EMPLOYEE_TOTAL_REQUEST = "/api/total-requests";

const GET_COMMON_PROJECT = "/api/projects/create";
const CREATE_PROJECT = "/api/projects";
const GET_DETAIL_PROJECT = "/api/projects";
const UPDATE_PROJECT = "/api/projects";
const LIST_ACCOUNT = "/api/accounts";
const RESET_PASSWORD = "/api/accounts/reset-password";
const LIST_RESOURCE_SITUATION = "/api/projects/resource-situation";

const REVIEWS = "/api/project-management/:id/overview";
const GET_COMMON_EMPLOYEES = "/api/common/employees"

const LIST_SABBATICAL_LEAVE_REQUEST = "/api/sabbatical-leave-requests";
const SHOW_SABBATICAL_LEAVE_REQUEST = "/api/sabbatical-leave-requests";
const SABBATICAL_LEAVE = "/api/sabbatical-leave-requests/sabbatical-days-off";
const SABBATICAL_DASHBOARD_DAYS_OFF = "/api/sabbatical-days-off/get-count";
const SABBATICAL_LOG = "/api/sabbatical-leave-requests/sabbatical-log-all";
const SABBATICAL_DAYS_OFF = "/api/sabbatical-leave-requests/sabbatical-leave";

const SHOW_ADDITIONAL_TIMESHEET = "/api/additional-timesheet";
const LIST_ADDITIONAL_TIMESHEET = "/api/additional-timesheet";
const DELETE_ADDITIONAL_TIMESHEET = "/api/additional-timesheet";
const TIME_SHEET_SUMMARY = "/api/timesheets/summary";
const SKILL_SHEET = "/api/skillsheet";
const ADD_SKILL_SHEET = "/api/skillsheet";

const GET_COMMON_CONTRACT_EMPLOYEE = "/api/contract-employee/create";
const CREATE_CONTRACT_EMPLOYEE = "/api/contract-employee/";
const EDIT_CONTRACT_EMPLOYEE = "/api/contract-employee";
const UPDATE_CONTRACT_EMPLOYEE = "/api/contract-employee";
const LIST_CONTRACT_EMPLOYEE = "/api/contract-employee";
const SHOW_SKILL_SHEET = "/api/skillsheet";

const LIST_SABBATICAL_COMPENSATE_REQUEST = "/api/sabbatical-compensate";
const DETAIL_SABBATICAL_COMPENSATE_REQUEST =
  "/api/sabbatical-compensate/detail";

const LIST_EMPLOYEE_LEVEL = "api/employee-level";
const CREATE_EMPLOYEE_LEVEL = "api/employee-level";
const DELETE_EMPLOYEE_LEVEL = "api/employee-level";
const UPDATE_EMPLOYEE_LEVEL = "api/employee-level";

const HOLIDAY_SETTINGS = "api/holiday-settings";
const TIMESHEET_SUBMIT_PERIOD = "api/timesheet-submit-period";
const SABBATICAL_ADJUSTMENTS = "api/sabbatical-adjustments";
const ALL_EMPLOYEES = "api/employees/all";

const LIST_SEATING_CHART = "/api/entity";
const CREATE_SEAT = "/api/entity/store";
const UPDATE_SEAT = "/api/entity/update";
const DELETE_SEAT = "/api/entity/delete";
const GET_ALL_LIST_EMPLOYEE_SEAT = "/api/employees/get-not-location-yet";
const LIST_STAFF_SEAT = "/api/entity";

const LIST_TYPE_WORK_EMPLOYEE = "/api/employees/remote-working";
const UPDATE_TYPE_WORK_EMPLOYEE = "/api/employees/remote-working";
const LIST_PROJECT_REMOTE = "/api/projects/get-list-for-select"

//Dashboard
const GET_EMPLOYEEES = "/api/get-count-member";
const GET_EMPLOYEE_BY_COMPANY = "/api/get-count-member";
const GET_EMPLOYEE_SENIORITY = "api/get-employee-seniority";
const GET_COUNT_DIVISION = "/api/get-count-member/get-count-division";
const GET_EMPLOYEE_BY_GRADE = "/api/get-count-member/get-count-division";
const GET_COUNT_POSITION = "/api/get-count-member/positions";
const GET_FLUCTUATING_SENIORITY = "/api/get-fluctuating-employee";
const GET_TIMESHEET_SUBMITS = "/api/employees/remind/employee-list";
const GET_TIMESHEET_HISTORY = "/api/employees/remind/history";
const GET_TIMESHEET_UNSUBMIT = "/api/employees/remind/unsubmit";
const UPDATE_TIMESHEET_UNSUBMIT = "/api/employees/unsubmit/remind";
const RESEND_REMIND_UNSUBMIT = "/api/employees/unsubmit/remind-fail";
const GET_REMIND_HISTORY_LIST = "/api/employees/remind/history-list";
const GET_EMPLOYEE_REMIND_HISTORY_LIST = "/api/employees/remind/employee-remind-list";

//SUMMER TRIP
const LIST_EMPLOYEE_SUMMER_TRIP = "/api/get-plan";
const LIST_FLIGHT_DETAIL = '/api/list-flight-detail';
const LIST_TEAM_NAMES = '/api/summertrip-list-team-name';
const GET_SUMMER_TRIP_FOR_OVERVIEW = '/api/get-summer-trip-for-overview';
const GET_SUMMER_TRIP_MASTER_DETAIL = '/api/get-summer-trip-master-detail';
const UPDATE_SUMMER_TRIP_MASTER = '/api/summer-trip-master';

// project management
const PROJECT_MANAGEMENT = {
  PROJECT_DETAIL: "/api/projects",
  EFFORT: '/api/project-management',
  UPDATE_PROJECT_DETAIL: "/api/projects/:id/update",
  REVIEWS: "/api/projects/:id/overview",
  CREATE_CONTRACT_HISTORY: "/api/contract-history/create",
  UPDATE_CONTRACT_HISTORY: "/api/contract-history/update",
  CONTRACT_HISTORY: "/api/contract-history/:id",
  EFFORT_EMPLOYEE_PROJECT: '/api/project-management/:id/effort-employees',
  EFFORT_EMPLOYEE_PROJECT_DETAIL: '/api/project-management/:id/effort-employees/detail',
  UPDATE_PROJECT_EMPLOYEE: '/api/project-management/:id/project-employee',
  GET_EMPLOYEE_EFFORT: "/api/project-management/employees/:id/efforts",
  GET_EMPLOYEE_PROJECT_HISTORY: "/api/project-management/history-project-list/:id",
  OVERVIEW_PROJECTS: "/api/project-management/overview-projects"
};
// Short Leave Request APIs
const LIST_SHORT_LEAVE_REQUEST = "/api/short-leave-requests"
const LIST_SHORT_LEAVE_REQUEST_ASSIGN = "/api/short-leave-requests/assign"
const LIST_SHORT_LEAVE_REQUEST_EXPORT = "/api/short-leave-requests/export"

export default {
  LIST_COMMON,
  LIST_EMPLOYEE,
  SHOW_EMPLOYEE,
  DELETE_EMPLOYEE,
  CREATE_EMPLOYEE,
  UPDATE_EMPLOYEE,
  GET_EMPLOYEE,
  GET_INFORMATION_EMPLOYEE,
  IMPORT_EMPLOYEE_NUMBER_OF_LEAVE,
  LIST_CUSTOMER,
  RESIGNATION,
  LIST_OVERTIME_REQUEST,
  SHOW_OVERTIME_REQUEST,
  LIST_REMOTE_REQUEST,
  SHOW_REMOTE_REQUEST,
  CHART_INFORMATION,
  LOGIN,
  REFRESH_TOKEN,
  ACCOUNT,
  CHANGE_PASSWORD,
  LIST_PROJECT,
  GET_COMMON_PROJECT,
  CREATE_PROJECT,
  GET_DETAIL_PROJECT,
  UPDATE_PROJECT,
  REVIEWS,
  TIME_SHEET,
  USER_TIME_SHEET,
  USER_CHECK_IN,
  USER_CHECK_OUT,
  TIME_SHEET_REQUEST,
  IMPORT_TIMESHEET,
  TIME_SHEET_TODAY,
  GET_EMPLOYEE_TIMESHEET_SUMMARY,
  GET_EMPLOYEE_TIMESHEET_DETAIL,
  GET_EMPLOYEE_TOTAL_REQUEST,
  LIST_ACCOUNT,
  RESET_PASSWORD,
  CREATE_NOTE_EMPLOYEE,
  LIST_SABBATICAL_LEAVE_REQUEST,
  LIST_EMPLOYEE_DAYS_OFF,
  UPDATE_DAYS_OFF,
  SHOW_SABBATICAL_LEAVE_REQUEST,
  SHOW_ADDITIONAL_TIMESHEET,
  LIST_ADDITIONAL_TIMESHEET,
  DELETE_ADDITIONAL_TIMESHEET,
  TIME_SHEET_SUMMARY,
  GET_COMMON_CONTRACT_EMPLOYEE,
  CREATE_CONTRACT_EMPLOYEE,
  EDIT_CONTRACT_EMPLOYEE,
  UPDATE_CONTRACT_EMPLOYEE,
  LIST_CONTRACT_EMPLOYEE,
  LIST_RESOURCE_SITUATION,
  SKILL_SHEET,
  ADD_SKILL_SHEET,
  SHOW_SKILL_SHEET,
  LIST_SABBATICAL_COMPENSATE_REQUEST,
  DETAIL_SABBATICAL_COMPENSATE_REQUEST,
  LIST_EMPLOYEE_LEVEL,
  CREATE_EMPLOYEE_LEVEL,
  DELETE_EMPLOYEE_LEVEL,
  UPDATE_EMPLOYEE_LEVEL,
  HOLIDAY_SETTINGS,
  TIMESHEET_SUBMIT_PERIOD,
  SABBATICAL_ADJUSTMENTS,
  ALL_EMPLOYEES,
  GET_EMPLOYEE_SKILL,
  LIST_SEATING_CHART,
  CREATE_SEAT,
  UPDATE_SEAT,
  DELETE_SEAT,
  GET_ALL_LIST_EMPLOYEE_SEAT,
  LIST_STAFF_SEAT,
  LIST_TYPE_WORK_EMPLOYEE,
  UPDATE_TYPE_WORK_EMPLOYEE,
  LIST_PROJECT_REMOTE,
  GET_EMPLOYEEES,
  GET_EMPLOYEE_BY_COMPANY,
  GET_EMPLOYEE_SENIORITY,
  GET_COUNT_DIVISION,
  GET_EMPLOYEE_BY_GRADE,
  GET_FLUCTUATING_SENIORITY,
  GET_COUNT_POSITION,
  //SUMMER_TRIP
  LIST_EMPLOYEE_SUMMER_TRIP,
  LIST_FLIGHT_DETAIL,
  LIST_TEAM_NAMES,
  GET_SUMMER_TRIP_FOR_OVERVIEW,

  GET_TIMESHEET_SUBMITS,
  GET_TIMESHEET_HISTORY,
  GET_TIMESHEET_UNSUBMIT,
  UPDATE_TIMESHEET_UNSUBMIT,
  GET_SUMMER_TRIP_MASTER_DETAIL,
  UPDATE_SUMMER_TRIP_MASTER,
  PROJECT_MANAGEMENT,
  LIST_PROJECT_CUSTOMERS,
  LIST_EMPLOYEE_TO_SELECT,
  LIST_POSITION,
  GET_REMIND_HISTORY_LIST,
  RESEND_REMIND_UNSUBMIT,
  GET_EMPLOYEE_REMIND_HISTORY_LIST,
  GET_COMMON_EMPLOYEES,
  GET_RESOURCE_STATISTICS,
  GET_RESOURCE_DIVISION_STATISTICS,
  GET_RESOURCE_SE_STATISTICS,
  FOOT_DIVISION,
  GET_RESOURCE_EFFORT_STATISTICS,
  GET_PROJECT_STATUS_STATISTICS,
  GET_PROJECT_CHARGE_PROJECTS,
  GET_PROJECT_IN_CHARGE_MANMONTH,
  GET_DATA_MM_YEAR,

  SABBATICAL_DAYS_OFF,
  SABBATICAL_LOG,
  SABBATICAL_LEAVE,
  SABBATICAL_DASHBOARD_DAYS_OFF,

  // Short Leave Request APIs
  LIST_SHORT_LEAVE_REQUEST,
  LIST_SHORT_LEAVE_REQUEST_ASSIGN,
  LIST_SHORT_LEAVE_REQUEST_EXPORT
}
